import React from "react";
import CheckedLink from "../../reusables/CheckedLink";
import "./index.scss";

export default function EventsCards({ data }) {
	return (
		<ul className="section-cards--events">
			{data?.map(({ heading, description, link, eventDetails, id }) => (
				<div className="section-item">
					<li id={id}>
						{heading && description && (
							<div className="contain">
								<h4>{heading}</h4>

								<p className="small text-justify">
									{description}
								</p>

								{eventDetails && (
									<div className="d-flex justify-content-between align-items-center w-100">
										<span>
											Date: <br /> {eventDetails.date}
										</span>
										<span>
											Duration: <br />
											{eventDetails.duration}
										</span>
										<span>
											Price:
											<br />
											{eventDetails.price}
										</span>
									</div>
								)}

								<CheckedLink link={link}>
									Learn more
								</CheckedLink>
							</div>
						)}
					</li>
				</div>
			))}
		</ul>
	);
}
